import React from 'react';

export const LazyBimViewer = React.lazy(() => import('./BimViewer'));
